import { ChevronUpIcon } from "@talladega/icons";
import { cleanParagraphTags } from "@talladega/helpers";
import { Disclosure, Transition } from "@headlessui/react";
import classNames from "classnames";
import { FaqLayout } from "@talladega/types";
import { CmsHeading } from "../CmsHeading";

export const Faq = ({ heading, subheading, faqSections }: FaqLayout) => {
  return (
    <div
      className="mx-auto max-w-page items-center gap-6 px-4 pb-6 pt-10 lg:gap-24 lg:px-5 lg:py-16"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <div className="items-center justify-center pb-6 text-center">
        {heading && (
          <CmsHeading
            headingLevel={heading.headingGroup?.headingLevel}
            textSize={heading.headingGroup?.textSize}
            text={heading.headingGroup?.text}
            htmlId={heading.headingGroup?.htmlId}
          />
        )}
        {subheading && (
          <div className="mt-4 lg:mt-8">
            <CmsHeading
              headingLevel={subheading.headingGroup?.headingLevel}
              textSize={subheading.headingGroup?.textSize}
              text={subheading.headingGroup?.text}
              htmlId={subheading.headingGroup?.htmlId}
            />
          </div>
        )}
      </div>
      {faqSections && faqSections.length > 0 && (
        <div>
          {faqSections.map((section, index) => {
            return (
              <div
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                tabIndex={index}
                key={`${section.faqSectionHeading}-container`}
                className="pb-4"
              >
                <Disclosure>
                  {({ open }) => (
                    <div
                      key={section.faqSectionHeading}
                      className="rounded-lg bg-white"
                    >
                      <Disclosure.Button
                        className={classNames(
                          "flex w-full justify-between rounded-lg bg-white px-6 py-4 text-left focus:outline-none",
                          { "rounded-b-none": open }
                        )}
                      >
                        <h5
                          itemProp="name"
                          className={classNames("inline-block", {
                            "text-primary-500": open,
                          })}
                        >
                          {section.faqSectionHeading}
                        </h5>
                        <ChevronUpIcon
                          className={`${
                            open
                              ? "text-primary-500"
                              : "rotate-180 transform text-primary-deep"
                          } h-6 w-6`}
                        />
                      </Disclosure.Button>
                      <Transition
                        unmount={false}
                        enter="transition duration-100 ease-out"
                        enterFrom="transform scale-95 opacity-0"
                        enterTo="transform scale-100 opacity-100"
                        leave="transition duration-75 ease-out"
                        leaveFrom="transform scale-100 opacity-100"
                        leaveTo="transform scale-95 opacity-0"
                      >
                        <Disclosure.Panel
                          unmount={false}
                          className="text-md rounded-b-lg bg-white px-6 focus:outline-none"
                        >
                          <div
                            itemScope
                            itemProp="acceptedAnswer"
                            itemType="https://schema.org/Answer"
                          >
                            <div
                              itemProp="text"
                              key={`${section.faqSectionHeading}-content`}
                              className="pb-2 [&>ul]:list-inside [&>ul]:list-disc"
                              // eslint-disable-next-line react/no-danger
                              dangerouslySetInnerHTML={{
                                __html: cleanParagraphTags(
                                  section.faqSectionContent
                                ),
                              }}
                            />
                          </div>
                        </Disclosure.Panel>
                      </Transition>
                    </div>
                  )}
                </Disclosure>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default {};
